//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Head from "../../components/masterpiece/Head";
import Description from "../../components/masterpiece/Description";
import Foot from "../../components/masterpiece/Foot";
import Preloader from '~/components/other/Preloader'

export default {
  components: {
    Head,
    Description,
    Foot,
    Preloader
  },
  computed: {
    masterpiece() {
       if (this.getMasterpiece?.data?.data.hasOwnProperty('id')) {
        return this.getMasterpiece.data.data
      } else {
        return false
      }
    },
    showFoot() {
      if (this.getMasterpiece?.data?.data.hasOwnProperty('author')) {
        const author = this.getMasterpiece.data.data.author
        if (this.$i18n.locale === 'ru') {
          return author !== null && (author[0].name.indexOf('Неизвестн') === -1 || author[0].name === 'Эрнст Неизвестный')
        } else {
          return author !== null
        }
      } else {
        return false
      }
    }
  },
  head() {
    const seo = this.masterpiece?.seo || {}
    let title = seo.browserTitle
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }
    return {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: seo.browserTitle },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords },
        { hid: 'image', name: 'image', content: seo.image },
        { hid: 'og:image', name: 'og:image', content: seo.image }
      ]
    }
  },
  chimera: {
    getMasterpiece () {
      return {
        url: '/api/v1/gallery/getById/',
        key: `masterpiece-detail-${this.$route.params.id}`,
        auto: true,
        params: {
          id: this.$route.params.id,
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success () {
            if (!this.getMasterpiece?.data?.data.hasOwnProperty('id')) {
              this.$nuxt.error({ statusCode: 404 })
            }
          }
        }
      }
    }
  }
}
